import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Download, ArrowLeft, BookOpen } from 'lucide-react';

const BookThanks = () => {
  const [isAllowed, setIsAllowed] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const check = async () => {
      const params = new URLSearchParams(window.location.search);
      const emailToken = params.get('t');

      if (emailToken) {
        try {
          const exchange = await fetch(`/api/exchange-email-token?t=${encodeURIComponent(emailToken)}`);
          if (exchange.ok) {
            params.delete('t');
            const nextQuery = params.toString();
            const nextUrl = `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ''}`;
            window.history.replaceState({}, '', nextUrl);
          }
        } catch {
          // If exchange fails, download check below will handle access.
        }
      }

      try {
        const response = await fetch('/api/download-check');
        if (!response.ok) {
          setIsAllowed(false);
        }
      } catch {
        setIsAllowed(false);
      }
    };

    check();
  }, []);

  return (
    <div className="book-thanks overflow-x-clip">
      <section className="section bg-white">
        <div className="container mx-auto px-4 sm:px-5 min-w-0">
          <div className="max-w-3xl mx-auto bg-gray-50 rounded-2xl sm:rounded-3xl p-6 sm:p-10 lg:p-14 shadow-xl text-center min-w-0">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-6 text-brand-dark-blue break-words">
              Ďakujeme!
            </h1>
            <p className="text-lg lg:text-xl text-gray-700 mb-10 leading-relaxed">
              Váš formulár bol úspešne odoslaný. Knihu si môžete stiahnuť kliknutím na tlačidlo nižšie.
            </p>

            {isAllowed ? (
              <button
                type="button"
                onClick={() => {
                  setIsDownloading(true);
                  window.location.href = '/api/download-book';
                }}
                disabled={isDownloading}
                className="inline-flex items-center justify-center bg-gradient-to-r from-brand-orange to-red-500 text-white font-bold py-4 px-8 rounded-xl hover:shadow-xl transition-all text-lg disabled:opacity-60"
              >
                <Download size={24} className="mr-2" />
                {isDownloading ? 'Sťahuje sa…' : 'Stiahnuť knihu'}
              </button>
            ) : (
              <div className="space-y-4">
                <p className="text-sm text-gray-600">
                  Tento odkaz je dostupný len po vyplnení formulára na stránke knihy.
                </p>
                <Link
                  to="/kniha"
                  className="inline-flex items-center justify-center bg-brand-dark-blue text-white font-bold py-3 px-6 rounded-xl hover:shadow-xl transition-all text-base"
                >
                  <BookOpen size={20} className="mr-2" />
                  Späť na stránku knihy
                </Link>
              </div>
            )}

            <div className="mt-8">
              <Link to="/" className="inline-flex items-center text-brand-dark-blue hover:text-brand-orange font-semibold">
                <ArrowLeft size={18} className="mr-2" />
                Späť na úvodnú stránku
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BookThanks;
